import moment from 'moment';
import React from 'react';

import '../styles/list.scss';
import { R$ } from '../utils/brl';
import Container from './layout/container';

export default ({ rifas, onSelect, title, isSmallSize=false, finishedList=false }) => {
    if (!rifas) rifas = [];

    return (
        <Container containerClassName="list">
            <p className="rifa-title text-center" style={{marginTop: 0}}>
                {title}
            </p>
            <main className="rifa-card-list">
                {rifas.map((rifa, index) => {
                    const { title, image, shortDescription: description, result, isEmphasis, dateOptions, value, raffleTime, raflleBlockTime, endSales } = rifa;
                    const blockDate =  new Date(`${dateOptions[0].split(' ')[0]} ${raflleBlockTime}`);
        
                    const endingTagMessage = moment().diff(moment(blockDate), 'minutes') >= -120 ? "hurry-up" : "acquire-now";
                    
                    return <div className={`rifa-card ${(isSmallSize||!isEmphasis)&&'small-card'}`} onClick={() => {if(onSelect) onSelect(rifa)}} style={{cursor:onSelect?'pointer':'default'}}>
                        <div className="rifa-card-image-wrapper">
                            <img src={image} className={`rifa-card__image ${(isSmallSize||!isEmphasis)&&'small-card'}`} />
                        </div>
                        <div className={`rifa-card__content`}>
                            <p className="rifa-card__title">{title}</p>
                            <div className="rifa-card__description-holder">                             
                                {description && <p className="rifa-card__description">{description}</p>}
                                {finishedList && <React.Fragment>
                                    <React.Fragment>
                                        <p className="rifa-card__description">{`Data do sorteio ${moment(dateOptions[0]).format('DD/MM/YYYY')} às ${raffleTime}`}</p>
                                        {result.length > 0 ? 
                                            <span className="rifa-card__title quota">Número Sorteado:{` ${result}`}</span>
                                            :
                                            <span className="rifa-card__title awaiting">Aguardando Sorteio</span>
                                        }
                                    </React.Fragment>

                                    {rifa.winners.length > 0 && 
                                        (<div className='rifa-card__winner'>
                                            { rifa.winners.map((winner) => <p><strong>Ganhador</strong>: {winner.name}</p>)}
                                        </div>)
                                    }
                                    
                                </React.Fragment>
                                }
                                {!finishedList && 
                                    <React.Fragment>
                                        {!description && 
                                            <React.Fragment>
                                                <p className="rifa-card__description">{`O sorteio acontecerá no dia ${moment(dateOptions[0]).format('DD/MM/YYYY')}`}</p>
                                                <p className="rifa-card__description">{`Cota por apenas ${R$(value)}`}</p>
                                            </React.Fragment>
                                        }
                                        {endingTagMessage === "hurry-up" ?
                                            <p><span className="rifa-ending__message hurry-up">Corre que está acabando!</span></p>
                                            :
                                            <p><span className="rifa-ending__message" style={{backgroundColor: "var(--primary)", color: "var(--light)"}}>Adquira já</span></p>
                                        }
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                    }
                )}
            </main>
        </Container>
    )
};


// WEBPACK FOOTER //
// ./src/rifa/components/list.jsx